import { CARGO_TYPE, TItemType } from '@types';

/** What an Item type's ranges count: "Bundles" or "Skids". */
export const formatItemTypeUnits = (itemType: Pick<TItemType, 'cargo_type'>) => {
	return itemType.cargo_type === CARGO_TYPE.SKID ? 'Skids' : 'Bundles';
}
